import {
  ResponsiveModal,
  ResponsiveModalContent,
  ResponsiveModalDescription,
  ResponsiveModalFooter,
  ResponsiveModalTitle,
  ResponsiveModalTrigger,
} from '@/components/extension/responsive-modal'
import { useEffect, useState } from 'react'
import { Button } from '../ui/button'
import { SelectPicker } from '../ui/select-picker'

type Props = {
  onClose: () => void
  title: string
  onConfirm: (selected: Record<string, number | null>, value?: string) => void
  pickers: {
    key: string
    title?: string
    options: { label: string; value: string }[]
    className?: string
    perspective?: 'left' | 'right'
    selected?: string
  }[]
}

export const ModalPicker = ({ onClose, title, onConfirm, pickers }: Props) => {
  const [selected, setSelected] = useState<Record<string, number | null>>({})
  const [value, setValue] = useState('')

  useEffect(() => {
    const initialSelected = pickers.reduce(
      (acc, cur) => {
        acc[cur.key] = cur.selected ? Number(cur.selected) : null
        return acc
      },
      {} as Record<string, number | null>
    )
    setSelected(initialSelected)
  }, [pickers])

  const handleSelect = (value: number, key: string) => {
    setSelected((prev) => ({
      ...prev,
      [key]: value,
    }))

    setValue(value.toString())
  }
  return (
    <ResponsiveModal onOpenChange={onClose} open>
      <ResponsiveModalTrigger />

      <ResponsiveModalContent
        className='z-[103] gap-0 border-none px-0 py-8 pb-4'
        aria-describedby={'modal-change-password'}
        overlayClassName='z-[103]'
      >
        <ResponsiveModalTitle className='mb-6 px-5 font-criteria text-[28px] font-normal leading-8 text-neutral-900'>
          {title}
        </ResponsiveModalTitle>
        <ResponsiveModalDescription />
        <div className='flex gap-3 px-5 pb-2'>
          {pickers.map((picker) => {
            const selectedIndex = picker.options.findIndex(
              (option) => Number(option.value) === Number(picker.selected)
            )
            return (
              <SelectPicker
                key={picker.key}
                title={picker.title}
                options={picker.options.map((opt) => ({
                  label: opt.label,
                  value: Number(opt.value),
                }))}
                className={picker.className}
                perspective={picker.perspective}
                selected={selectedIndex}
                onChange={(value) => handleSelect(value, picker.key)}
              />
            )
          })}
        </div>

        <ResponsiveModalFooter className='flex-row justify-end gap-3 border-t border-t-neutral-200 px-5 pt-4'>
          <Button variant={'neutral'} className='flex-1' onClick={onClose}>
            Đóng
          </Button>
          <Button
            variant={'black'}
            className='flex-1'
            onClick={() => onConfirm(selected, value)}
          >
            Xác nhận
          </Button>
        </ResponsiveModalFooter>
      </ResponsiveModalContent>
    </ResponsiveModal>
  )
}
